/**
 * Rounds a dollar amount to the nearest cent the same way hex-pc does for every
 * storefront price (`roundToNearestCent` in hex-pc's `src/common/utils`). The
 * displayed total and hex-pc's quote only agree to the cent if both round each
 * item with this exact formula.
 */
export const roundToNearestCent = (price: number): number =>
  Math.round(price * 100) / 100;
